import Vue from 'vue';
import Vuex from 'vuex';

import currentPage from '@/store/modules/currentPage';
import setup from '@/store/modules/setup';

// extensions
import event from '@/extensions/event-manager/store/modules/event';

// install Vuex
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
    modules: {
        // CMS, // global
        setup, // global
        currentPage, // namespaced

        // extensions
        event, // namespaced
    },
    strict: debug,
});

export default store;
